import React from "react";
import { Link } from "react-router-dom";

const ErrorPage = () => {
  return (
    <div className="container">
      <h1 className="title">Oops! Something Went Wrong</h1>
      <p className="message">
        You are not authorized to view this page. Please log in again.
      </p>
      <Link to="/" className="link">
        Go to Home
      </Link>
    </div>
  );
};

export default ErrorPage;
